{
  "validation.required": "{{label}} je povinné pole",
  "validation.minLength": "{{label}} musí obsahovat alespoň {{min}} znaků",
  "validation.maxLength": "{{label}} nemůže být delší než {{max}} znaků",
  "validation.contentTypeAlphanumeric": "{{label}} musí být alfanumerický",
  "validation.contentTypeDate": "{{label}} musí být datum",
  "validation.contentTypeDateBefore": "{{label}} musí být datum před {{date beforeDate}}",
  "validation.contentTypeDateAfter": "{{label}} musí být datum po {{date afterDate}}",
  "validation.contentTypeDatetime": "{{label}} musí být datum a čas",
  "validation.contentTypeDatetimeBefore": "{{label}} musí být datum před {{datetime beforeDate}}",
  "validation.contentTypeDatetimeAfter": "{{label}} musí být datum po {{datetime afterDate}}",
  "validation.contentTypeEmail": "{{label}} musí být e-mail",
  "validation.contentTypeInteger": "{{label}} musí být číslo",
  "validation.contentTypeNumber": "{{label}} musí být číslo",
  "validation.contentTypeRegex": "{{label}} má nesprávný formát",
  "validation.contentTypeText": "{{label}} musí být text",
  "validation.contentTypeTime": "{{label}} musí být čas",
  "validation.contentTypeUrl": "{{label}} musí být webová adresa",
  "select-element.default-option": "Vybrat…",
  "button-element.network-required":"Momentálně jste offline. Chcete-li pokračovat, vytvořte síťové připojení."
}